module.exports = __webpack_public_path__ + "img/arrow.3bf798d3.png";